angular.module('hcap-analytics')
.controller('UserDetailsCtrl', ['$scope','$stateParams','$http','$state','UserService', function($scope,$stateParams,$http,$state,UserService) {

  $scope.data = {
    roleOptions: ['User', 'Organizer', 'csm_admin', 'Administrator'],
    roles: {},
    csm: {},
  };

	UserService.getUserDetails($stateParams.guid, function(response){
    const roles = Array.isArray(response.user.roles) ? response.user.roles : response.user.role ? [response.user.role] : [];
    $scope.data.roleOptions.forEach(role => {
      $scope.data.roles[role] = roles.indexOf(role) !== -1;
    });
    $scope.data.user = response.user;
    $scope.data.isCsmAdmin = roles.indexOf('csm_admin') !== -1 || roles.indexOf('Administrator') !== -1;
    $scope.data.cohortCount = response.cohortCount || 0;
    $scope.data.csm = {
      maxCohorts: response.user.csm?.maxCohorts || null,
    };

		$scope.details = {
			user: JSON.stringify(response.user, null, 4),
			participants: JSON.stringify(response.participants, null, 4),
			designatedRaters: JSON.stringify(response.designatedRaters, null, 4)
		};
	});

  $scope.onRolesChange = () => {
    const roles = $scope.data.roleOptions.filter(role => $scope.data.roles[role]);
    UserService.setRoles($scope.data.user.guid, roles).then(() => {
      location.reload();
    });
  };

  $scope.onCsmSave = () => {
    const csmData = {};
    if ($scope.data.csm.maxCohorts !== null && $scope.data.csm.maxCohorts !== undefined) {
      csmData.maxCohorts = Number($scope.data.csm.maxCohorts);
    }
    UserService.updateCsm($scope.data.user.guid, csmData).then(() => {
      location.reload();
    });
  };

}]);
